<mat-dialog-content size="lg">
  <h1 class="font-semibold text-2xl pb-3">
    Actualizar Diseño
  </h1>
  <form [formGroup]="form" class="flex flex-col gap-6 p-3">
    @if (data) {
    <div class="flex flex-col gap-6">
      <div>
        <label for="name" class="text-gray-500">Nombre</label>
        <input id="name" type="text" formControlName="name" [disabled]="true"
          class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
          [ngClass]="{'border-red-500':f['name'].invalid && (f['name'].touched || f['name'].dirty)}" />
        @if (f['name'].touched && f['name'].invalid) {
        <p class="text-red-500 text-sm mt-1">
          Nombre es requerido.
        </p>
        }
      </div>
    </div>
    <div class="flex flex-col gap-6">
      <div>
        <label for="images" class="text-gray-500">Imágen del Color</label>
        <div class="p-2">
          <p-fileupload #fileUpload name="demo[]" uploadLabel=" " uploadIcon="a" [customUpload]="true"
            (onSelect)="addProductImages($event)" [multiple]="false" (onClear)="removeAllProductImages()"
            [files]="form.value['images'] || []" accept="image/*" mode="advanced">
            <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
              let-uploadCallback="uploadCallback">
              <div class="flex items-center flex-1 gap-4">
                <app-button [label]="'Seleccionar Imágen'" [icon]="'fi-rr-plus'" (click)="choose($event, chooseCallback)"></app-button>
              </div>
            </ng-template>
            <ng-template #content let-files let-removeFileCallback="removeFileCallback">
              @if (files?.length > 0) {
              <div>
                <div class="flex flex-wrap gap-4">
                  @for (file of files; track file; let i = $index) {
                  <div class="p-2 flex flex-row items-center gap-2">
                    <div>
                      <img role="presentation" [alt]="file.name" [src]="file.objectURL" width="50" height="50" />
                    </div>
                    <span class="max-w-60 whitespace-nowrap overflow-hidden">{{ file.name }}</span>
                    <i class="fi-rr-trash text-2xl text-red-400 cursor-pointer hover:text-red-600"
                      (click)="onRemoveTemplatingFile($event, file, removeFileCallback, i)"></i>
                  </div>
                  }
                </div>
              </div>
              }
            </ng-template>
            <ng-template #file></ng-template>
            <ng-template #empty>
              <div class="flex items-center justify-center flex-col">
                <i class="fi-rr-upload text-2xl "></i>
                <p class="mt-6 mb-0">Arrastra y suelta las imágenes.</p>
              </div>
            </ng-template>
          </p-fileupload>
        </div>
      </div>
    </div>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions class="gap-2 flex flex-row">
  <button class="rounded-3xl flex items-center gap-2 bg-gray-400 text-white py-2 px-4 cursor-pointer hover:bg-gray-600"
    (click)="close(false)">
    <span class="text-base">Cancelar</span>
    <i class="fi-rr-ban text-base flex"></i>
  </button>
   <button
    class="rounded-3xl flex items-center gap-2 bg-orange-500 text-white py-2 px-4 cursor-pointer hover:bg-orange-600 disabled:bg-orange-200 disabled:cursor-not-allowed"
    (click)="update()" [disabled]="form.invalid">
    <span class="text-base">Guardar</span>
    <i class="fi-rr-disk text-base flex"></i>
  </button>
</mat-dialog-actions>
